import Ajax from "../DataJson/tutorials/Ajax.json";
import Angular from "../DataJson/tutorials/Angular.json";
import ASP from "../DataJson/tutorials/ASP.json";
import AWS from "../DataJson/tutorials/AWS-cloud.json";
import Bash from "../DataJson/tutorials/Bash.json";
import Bootstrap3 from "../DataJson/tutorials/Bootstrap3.json";
import Bootstrap4 from "../DataJson/tutorials/Bootstrap4.json";
import Bootstrap5 from "../DataJson/tutorials/Bootstrap5.json";
import Canva from "../DataJson/tutorials/Canva.json";
import ChatGPT from "../DataJson/tutorials/ChatGPT.json";
import Colors from "../DataJson/tutorials/Colors.json";
import CPlusPlus from "../DataJson/tutorials/CPlusPlus.json";
import Cprograming from "../DataJson/tutorials/Cprograming.json";
import CSharp from "../DataJson/tutorials/CSharp.json";
import CSS from "../DataJson/tutorials/CSS.json";
import CyberSecurity from "../DataJson/tutorials/CyberSecurity.json";
import DataScience from "../DataJson/tutorials/DataScience.json";
import Django from "../DataJson/tutorials/Django.json";
import DSA from "../DataJson/tutorials/DSA.json";
import Excel from "../DataJson/tutorials/Excel.json";
import Git from "../DataJson/tutorials/Git.json";
import Go from "../DataJson/tutorials/Go.json";
import Googlesheets from "../DataJson/tutorials/Googlesheets.json";
import Grabhics from "../DataJson/tutorials/Grabhics.json";
import HTML from "../DataJson/tutorials/HTML.json";
import Icons from "../DataJson/tutorials/Icons.json";
import Java from "../DataJson/tutorials/Java.json";
import JavaScript from "../DataJson/tutorials/JavaScript.json";
import jQuery from "../DataJson/tutorials/jQuery.json";
import Json from "../DataJson/tutorials/Json.json";
import Kotlin from "../DataJson/tutorials/Kotlin.json";
import Machinelearning from "../DataJson/tutorials/Machinelearning.json";
import Matplotlib from "../DataJson/tutorials/Matplotlib.json";
import MongoDB from "../DataJson/tutorials/MongoDB.json";
import MySQL from "../DataJson/tutorials/MySQL.json";
import Nodejs from "../DataJson/tutorials/Nodejs.json";
import NumPy from "../DataJson/tutorials/NumPy.json";
import Pandas from "../DataJson/tutorials/Pandas.json";
import PHP from "../DataJson/tutorials/PHP.json";
import Python from "../DataJson/tutorials/Python.json";
import R from "../DataJson/tutorials/R.json";
import ReactData from "../DataJson/tutorials/React.json";
import Rust from "../DataJson/tutorials/Rust.json";
import Sass from "../DataJson/tutorials/Sass.json";
import SQL from "../DataJson/tutorials/SQL.json";
import SVG from "../DataJson/tutorials/SVG.json";
import TypeScript from "../DataJson/tutorials/TypeScript.json";
import Vue from "../DataJson/tutorials/Vue.json";
import WebDevelopment from "../DataJson/tutorials/WebDevelopment.json";
import XML from "../DataJson/tutorials/XML.json";
import GenerativeAI from "../DataJson/tutorials/GenerativeAI.json";
import SciPY from "../DataJson/tutorials/SciPy.json";
import Statistics from "../DataJson/tutorials/Statistics.json";
import Bard from "../DataJson/tutorials/Bard.json";
import AppML from "../DataJson/tutorials/AppML.json";

const jsonFiles = {
  Ajax,
  Angular,
  AppML,
  ASP,
  AWS,
  Bash,
  Bard,
  Bootstrap3,
  Bootstrap4,
  Bootstrap5,
  Canva,
  ChatGPT,
  Colors,
  CPlusPlus,
  Cprograming,
  CSharp,
  CSS,
  CyberSecurity,
  DataScience,
  Django,
  DSA,
  Excel,
  Git,
  Go,
  GenerativeAI,
  Googlesheets,
  Grabhics,
  HTML,
  Icons,
  Java,
  JavaScript,
  jQuery,
  Json,
  Kotlin,
  Machinelearning,
  Matplotlib,
  MongoDB,
  MySQL,
  Nodejs,
  NumPy,
  Pandas,
  PHP,
  Python,
  R,
  React: ReactData,
  Rust,
  Sass,
  SciPY,
  Statistics,
  SQL,
  SVG,
  TypeScript,
  Vue,
  WebDevelopment,
  XML,
};

export default jsonFiles;
